<template>
    <div class="page">
        <site-header></site-header>

        <div class="banner">
            <div class="warp">
                <div class="content-left">
                    <h2>做私域电商，用梦饷云</h2>
                    <h3>新电商基础设施提供者</h3>
                    <p class="register" @click="handleRegister">立即开通</p>
                </div>
                <div class="content-right">
                    <img src="@/assets/imgs/banner-img.png" alt="" />
                </div>
            </div>
        </div>

        <!-- <dl class="excellent-enterprise">
            <dt>来自优秀企业的信任</dt>
            <dd>
                <img src="@/assets/imgs/brand-logo/27.png" />
                <img src="@/assets/imgs/brand-logo/26.png" />
                <img src="@/assets/imgs/brand-logo/25.png" />
                <img src="@/assets/imgs/brand-logo/24.png" />
                <img src="@/assets/imgs/brand-logo/23.png" />
                <img src="@/assets/imgs/brand-logo/22.png" />
                <img src="@/assets/imgs/brand-logo/21.png" />
                <img src="@/assets/imgs/brand-logo/28.png" />
            </dd>
        </dl> -->
        <div class="solution">
            <p class="desc">不仅仅是 SaaS 工具</p>
            <div class="title">企业私域流量运营解决方案</div>
            <ul class="solutionContent">
                <li v-for="(item, index) in solutionImages" :key="index">
                    <img :src="item.image" alt="" />
                    <p>{{ item.desc }}</p>
                </li>
                <li style="visibility:hidden;"></li>
            </ul>
        </div>
        <div class="preference">
            <ul>
                <!-- <li class="title">梦饷云精选特惠</li> -->
                <li class="title">
                    <span>抢先版</span> <strong> 3600 </strong> 元/年
                </li>
            </ul>
            <p>
                <button @click="handleRegister">立即开通</button>
            </p>
        </div>
        <div id="caseSwiper" class="case-swiper">
            <div class="swiper-container">
                <h2>信任企业案例</h2>
                <div class="swiper-wrapper">
                    <el-carousel type="card" :autoplay="false" height="510px">
                        <el-carousel-item>
                            <div class="swiper-slide">
                                <img
                                    src="https://akim-oss.aikucun.com/6216f8a75fd5bb3d5f22b6f9958cdede3fc086c2_1638325084626_24.png?x-oss-process=image/crop,g_center,w_520,h_510"
                                    alt=""
                                />
                                <div>
                                    <h3>好孩子</h3>
                                    <h4>
                                        好孩子妈咪星站--2人实现40万+社群运营
                                    </h4>
                                    <p>
                                        好孩子妈咪星站项目累计了33万私域粉丝，100+
                                        KOC，在流量增长、KOC活跃上遇到了瓶颈。
                                    </p>
                                    <p>
                                        2021年6月，通过梦饷导师带教、团长激活，爆品爆破，分销员招募、PK赛组织等一系列赋能策略，帮助好孩子重新激活私域，带来新的流量增长。
                                    </p>
                                    <p>
                                        用户活跃度提升2倍，客单价提升600%，营收增加300万+/月
                                    </p>
                                </div>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item>
                            <div class="swiper-slide">
                                <img
                                    src="https://akim-oss.aikucun.com/96da0f2e395aea8a360f2a990900b774902d39aa_1638342291292_55.jpeg"
                                    alt=""
                                />
                                <div>
                                    <h3>特步特享跑</h3>
                                    <h4>
                                        兴趣团长转变品牌团长
                                    </h4>
                                    <p>
                                        特步跑团项目累计了2000+的团长，与品牌销售是弱关系，需要建立强的品牌团长关系
                                    </p>
                                    <p>
                                        通过尖货发布，身份绑定，激活沉睡团长，招募新团长，刺激C端客户
                                    </p>
                                    <p>
                                        上线后人均复购1.5次，UV2.5万，转化率高达9.6%，客单400元
                                    </p>
                                </div>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item>
                            <div class="swiper-slide">
                                <img
                                    src="https://akim-oss.aikucun.com/dd5309b24d7042b8221c5216f420827970cc0217_1638342554381_11.png?x-oss-process=image/crop,x_0,y_240,w_520,h_510"
                                    alt=""
                                />
                                <div>
                                    <h3>沙拉时尚</h3>
                                    <h4>
                                        私域沉默粉丝激活
                                    </h4>
                                    <p>
                                        高端私域女装品牌，1/4的沉默会员难激活。
                                    </p>
                                    <p>
                                        大牌供应链引流、社群运营辅导，通过企业饷店实现沉默粉丝的重新激活。
                                    </p>
                                    <p>
                                        上线后人均复购1.6次，转化率高达13%，月度净利增长40万+
                                    </p>
                                </div>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item>
                            <div class="swiper-slide">
                                <img
                                    src="https://akim-oss.aikucun.com/8e66dc053c6614abce6ffb4d03f0d6d44a090e27_1638342595276_18.jpeg?x-oss-process=image/crop,g_center,w_520,h_510"
                                    alt=""
                                />
                                <div>
                                    <h3>御泥坊</h3>
                                    <h4>
                                        私域粉丝活跃度提升
                                    </h4>
                                    <p>
                                        国民美妆品牌，沉淀了上百万的私域会员，一直在寻找优质的异业合作供应链
                                    </p>
                                    <p>
                                        大牌供应链一键合作，优质素材帮助转化，售后处理保质保量。
                                    </p>
                                    <p>
                                        社群活跃提升2倍，转化率达11%，对接异业合作仅需1天。
                                    </p>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>

        <div class="case-list">
            <dl>
                <dt>
                    <p>
                        <img
                            src="https://akim-oss.aikucun.com/68b89f4639a9df7b3370ac2d19b2b82fb0215727_1638344396534_5.png"
                            alt=""
                        />
                    </p>
                </dt>
                <dd>
                    <h3>特步-特享跑</h3>
                    <p>
                        携手企业饷店完成兴趣团至品牌团转变，打造品牌KOL变现新价值
                    </p>
                </dd>
            </dl>

            <dl>
                <dt>
                    <p style="padding-top:5px; height:65px;">
                        <img
                            src="https://akim-oss.aikucun.com/f6517ea36b4945939843db8f5823befd64be5fec_1638344396436_55.png?x-oss-process=image/resize,h_50,m_lfit"
                            alt=""
                            style="width:56px,height:50px"
                        />
                    </p>
                </dt>
                <dd>
                    <h3>新华优品</h3>
                    <p>
                        多元的品牌供应链，给传统媒体流量平台带来新机会
                    </p>
                </dd>
            </dl>

            <dl>
                <dt>
                    <p>
                        <img
                            src="https://akim-oss.aikucun.com/e6dc0206493c1d8f53dbfa61f272e215389e20e6_1638344396417_4.png"
                            alt=""
                        />
                    </p>
                </dt>
                <dd>
                    <h3>TOUTOU</h3>
                    <p>
                        企业饷店助力打造私域个人强IP，老板娘一句话就能卖掉几千件
                    </p>
                </dd>
            </dl>

            <dl>
                <dt>
                    <p>
                        <img
                            src="https://akim-oss.aikucun.com/11cc093252341cc735241f9f28b37e99c9be3d28_1638344396500_85.png?x-oss-process=image/resize,h_70,m_lfit"
                            alt=""
                        />
                    </p>
                </dt>
                <dd>
                    <h3>沙拉时尚</h3>
                    <p>
                        让沉默客户变成头部会员
                    </p>
                </dd>
            </dl>
            <dl>
                <dt>
                    <p style="padding-top:6px; height:64px;">
                        <img
                            src="https://akim-oss.aikucun.com/363ef4f3c945e50bbb8b2a23cec57b2814e28be6_1638344396394_44.png?x-oss-process=image/resize,h_60,m_lfit"
                            alt=""
                        />
                    </p>
                </dt>
                <dd>
                    <h3>御泥坊</h3>
                    <p>
                        异业合作让社群产品结构多元，轻松提升转化率和留存率
                    </p>
                </dd>
            </dl>
            <dl>
                <dt>
                    <p>
                        <img
                            src="https://akim-oss.aikucun.com/89c16f9c4f6c51424a62498ee57a78a315ed61b5_1638344396373_3.png?x-oss-process=image/resize,h_70,m_lfit"
                            alt=""
                        />
                    </p>
                </dt>
                <dd>
                    <h3>好孩子</h3>
                    <p>
                        专业的社群带教，温馨的团长促活，通过企业饷店分销功能成功盘活好孩子私域粉丝
                    </p>
                </dd>
            </dl>
        </div>
        <div class="footer">
            <h3>联系我们</h3>
            <p>
                <img width="150px" height="150px" :src="contactQrCode" alt="" />
            </p>
            <p>13061613792</p>
            <a
                href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
                class="icp"
                target="_blank"
                >©2021梦饷集团 沪ICP备18031936号-3</a
            >
        </div>
        <el-dialog
            title="账号和联系信息"
            :visible.sync="dialogVisible"
            width="40%"
            class="dialogContact"
        >
            <div class="content">
                <el-form label-position="left" label-width="100px">
                    <el-form-item label="开户行：">
                        <span>招商银行上海张杨支行</span>
                    </el-form-item>
                    <el-form-item label="户名：">
                        <span>上海饷点信息科技有限公司</span>
                    </el-form-item>
                    <el-form-item label="账号：">
                        <span>121934345610209</span>
                    </el-form-item>
                </el-form>
                <div class="right">
                    <div>
                        <div class="text">联系我们</div>
                        <img class="qrcode" :src="contactQrCode" />

                        <div class="tel">13061613792</div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>
<script>
import SiteHeader from '@/components/SiteHeader';
import contactQrCode from '@/assets/imgs/lianxi.png';
export default {
    name: 'Home',
    components: {
        SiteHeader
    },
    data() {
        return {
            excellentEnterpriseList: [],
            solutionImages: [
                {
                    id: '1',
                    image:
                        'https://akim-oss.aikucun.com/328d281a4503906caca75d291aa40576c9028395_1637918304030_28.png',
                    desc: '独立小程序商城，支持自主上架、自主装修'
                },

                {
                    id: '2',
                    image:
                        'https://akim-oss.aikucun.com/fbe6c59cb3f5bb50aa5dc160b62311babc46423a_1637918347926_15.png',

                    desc: '内嵌梦饷云供应链，一件代发、售后无忧'
                },
                {
                    id: '3',
                    image:
                        'https://akim-oss.aikucun.com/cd538cbd3ca0339979c09b03baf323376509032d_1637918347938_36.png',
                    desc: '大数据选品中心，定向匹配不同用户群体'
                },
                {
                    id: '4',
                    image:
                        'https://akim-oss.aikucun.com/366d957ac370a9c645f3f91b474a0f6624843063_1637918347949_99.png',

                    desc: '灵活分销体系，满足企业级员工管理需求'
                },
                {
                    id: '5',
                    image:
                        'https://akim-oss.aikucun.com/6ca877fcd0f6c34fd390f70bfdbe6a38dcb91848_1637918347960_12.png',
                    desc: '私域运营赋能顾问，助您成为私域运营专家'
                }
            ],
            contactQrCode,
            dialogVisible: false
        };
    },
    methods: {
        handleRegister() {
            // this.$router.push({
            //     path: '/register'
            // });
            this.dialogVisible = true;
        }
    },
    created() {
        const sUserAgent = navigator.userAgent.toLowerCase();
        if (
            /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
                sUserAgent
            )
        ) {
            //跳转移动端页面
            window.location.href = process.env.VUE_APP_MOBILE_CLOUD;
        }
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.page {
    overflow: auto;
    width: 100%;
    .register {
        padding: 0 25px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        background-color: #ffffff;
        border-radius: 4px;
        cursor: pointer;

        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #f6454a;
    }
    .banner {
        width: 100%;
        height: 600px;
        background: linear-gradient(267deg, #ff7f83 0%, #fe3f45 100%);
        .warp {
            width: 1188px;
            padding-top: 70px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            .content-left {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                padding-top: 90px;
                h2 {
                    font-size: 60px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #f2f2f2;
                    line-height: 84px;
                    margin-bottom: 18px;
                }
                h3 {
                    font-size: 26px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #f2f2f2;
                    line-height: 37px;
                    letter-spacing: 2px;
                    margin-bottom: 40px;
                }
            }
            .content-right {
                img {
                    width: 522px;
                    height: 464px;
                }
            }
        }
    }
    .excellent-enterprise {
        width: 1100px;
        padding-top: 47px;
        margin: 0 auto;
        dt {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 22px;
            margin-bottom: 23px;
            text-align: center;
        }
        dd {
            display: flex;
            justify-content: space-around;
            img {
                width: 120px;
                height: 52px;
            }
        }
    }

    .solution {
        padding-top: 80px;
        text-align: center;
        .desc {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 22px;
            margin-bottom: 23px;
            text-align: center;
        }
        .title {
            font-size: 36px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 30px;
            margin-bottom: 40px;
        }
        .solutionContent {
            width: 1190px;
            height: 492px;
            background-color: #1e1616;
            border-radius: 8px;
            background-image: url('~@/assets/imgs/solutionContent_bg.png');
            background-position: right bottom;
            background-repeat: no-repeat;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            padding-top: 48px;
            margin: 0 auto;
            li {
                width: 486px;
                height: 100px;
                background: #ffffff;
                border-radius: 6px;
                border: 1px solid #979797;
                display: flex;
                align-items: center;
                padding-left: 38px;
                p {
                    margin-left: 20px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 22px;
                }
            }
        }
    }
    .preference {
        width: 1102px;
        height: 100px;
        // background: linear-gradient(180deg, #ffffff 0%, #fff0f0 100%);
        border-radius: 8px;
        border: 1px solid #ffcaca;
        margin: 30px auto 80px auto;
        padding: 0 40px 0 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 0.85);
            line-height: 38px;
            strong {
                font-size: 28px;
                color: #ff9500;
                font-weight: 500;
            }
        }
        .desc {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 0.85);
            line-height: 22px;
            display: flex;
            align-items: flex-end;
            strong {
                font-size: 18px;
                color: #ff9500;
                font-weight: 500;
            }
        }
        p {
            button {
                width: 130px;
                height: 42px;
                background: #ff585e;
                border-radius: 4px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                border: none;
                cursor: pointer;
            }
        }
    }
    .case-swiper {
        width: 100%;
        background: #1e1616;
        .swiper-container {
            margin: 0 auto;
            padding: 60px 0;
            > h2 {
                font-size: 36px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(255, 255, 255, 0.85);
                line-height: 50px;
                text-align: center;
                margin-bottom: 30px;
            }
            > h4 {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                line-height: 39px;
                text-align: center;
            }
            .swiper-wrapper {
                width: 1702px;
                margin: 0 auto;
            }
        }
    }
    .case-list {
        width: 1192px;
        margin: 80px auto 40px auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        dl {
            width: 334px;
            height: 200px;
            background: #ffffff;
            border-radius: 8px;
            border: 1px solid #eaeaea;
            margin-bottom: 80px;
            dt {
                width: 334px;
                height: 60px;
                position: relative;
                // img:nth-child(1) {
                //     position: absolute;
                //     width: 334px;
                //     height: 160px;
                //     left: 0;
                //     top: 0;
                //     z-index: 0;
                // }
                p {
                    position: absolute;
                    width: 70px;
                    height: 70px;
                    left: 24px;
                    bottom: 25px;
                    z-index: 1;
                    border-radius: 50%;
                    background: #ffffff;
                    overflow: hidden;
                    box-shadow: 0 0 15px rgba(0, 0, 0, 0.56);
                    text-align: center;
                    img {
                        max-width: 70px;
                        margin: 0 auto;
                    }
                }
            }
            dd {
                padding: 0 24px;

                h3 {
                    font-size: 18px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    line-height: 25px;
                }
                p {
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 22px;
                    padding-top: 12px;
                }
            }
        }
    }
    .dialogContact {
        .content {
            display: flex;
            justify-content: space-between;
            font-size: 28px;
            .right {
                display: flex;
                text-align: center;
                padding-right: 90px;
                margin-top: -20px;
                .text {
                    font-size: 16px;
                    font-weight: 400;
                    color: #292929;
                    line-height: 32px;
                    letter-spacing: 3px;
                    font-weight: 700;
                }
                .tel {
                    font-size: 20px;
                    font-weight: 800;
                    color: #333333;
                    line-height: 32px;
                    letter-spacing: 1px;
                }
                .qrcode {
                    margin: 0 auto;
                    width: 150px;
                    height: 150px;
                }
            }
        }
    }
    .contact {
        padding: 80px 160px;
        display: flex;
        justify-content: space-between;
        .left {
            display: flex;

            .text {
                font-size: 24px;
                font-weight: 400;
                color: #292929;
                line-height: 36px;
                letter-spacing: 3px;
            }
            .tel {
                margin-top: 34px;
                font-size: 40px;
                font-weight: 800;
                color: #333333;
                line-height: 50px;
                letter-spacing: 6px;
            }

            .qrcode {
                margin-left: 20px;
                width: 120px;
                height: 120px;
            }
        }
        .right {
            .form {
                margin-top: 26px;
                .label {
                    font-size: 14px;
                    font-weight: 400;
                    color: #424242;
                    line-height: 20px;
                    letter-spacing: 1px;
                }
                .input {
                    margin-top: 6px;
                    width: 450px;
                    height: 38px;
                    border-radius: 5px;
                    border: 1px solid #e8e8e8;
                    outline: none;
                    padding: 10px;
                }
                .btn {
                    width: 208px;
                    height: 45px;
                    line-height: 45px;
                    background: #e51312;
                    border-radius: 5px;
                    text-align: center;
                    font-size: 18px;
                    font-weight: 400;
                    color: #ffffff;
                    letter-spacing: 2px;
                }
                .sub {
                    margin-top: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #8a8a8a;
                    line-height: 24px;
                    letter-spacing: 1px;
                }
            }
        }
    }
    .footer {
        width: 100%;
        background: #302e2e;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-weight: 400;
        line-height: 28px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        padding: 20px 0 20px 0;
        h3 {
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 90px;
        }
        .icp {
            line-height: 60px;
            color: #ffffff;
            text-decoration: none;
        }
    }
}
.el-carousel__item--card {
    width: 850px;
}
.swiper-slide {
    width: 850px;
    height: 510px;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    img {
        width: 520px;
        height: 510px;
    }
    div {
        width: 330px;
        height: 470px;
        background-color: #ffffff;
        padding: 20px;
        h3 {
            font-size: 26px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 85px;
            text-align: left;
        }
        h4 {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 25px;
        }
        p {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 22px;
            padding: 20px 0;
        }
    }
}
::v-deep {
    .el-form-item {
        margin: 0;
    }

    .el-form-item__label,
    .el-form-item__content {
        font-size: 18px;
    }
}
</style>
